module.exports = __webpack_public_path__ + "img/logo.a5e71c32.png";